// Project briefs on 99designs do not currently support WorkEntityField questions.

export function Edit() {
    return <div>Not yet implemented</div>;
}

export function View() {
    return <div>Not yet implemented</div>;
}

export function HasValue(): boolean {
    return false;
}

export function getValue() {
    return '';
}
